import { gql } from '@apollo/client';
import { client } from '../client';
import { PdaScanSetting } from '../queries/pdaScanSettingQueries';

export interface UpdateScanSettingInput {
  masterEnabled?: boolean;
  vibrateEnabled?: boolean;
  breathingLightEnabled?: boolean;
  soundEnabled?: boolean;
  soundId?: string;
}

export const UPDATE_MY_SCAN_SETTING = gql`
  mutation UpdateMyScanSetting($input: UpdateScanSettingInput!) {
    updateMyScanSetting(input: $input) {
      accountId
      warehouseId
      masterEnabled
      vibrateEnabled
      breathingLightEnabled
      soundEnabled
      soundId
      lastUpdatedByType
    }
  }
`;

export async function updateMyScanSetting(
  input: UpdateScanSettingInput
): Promise<PdaScanSetting | null> {
  const resp = await client.mutate<{ updateMyScanSetting: PdaScanSetting }, { input: UpdateScanSettingInput }>({
    mutation: UPDATE_MY_SCAN_SETTING,
    variables: { input },
  });
  return resp.data?.updateMyScanSetting ?? null;
}
